import firebase from "@/firebase/config";
import "firebase/auth";

const STAGING_MTP_APP_URL = "https://mtp.skilltech.team";
const PRODUCTION_MTP_APP_URL = "https://mtp.skilltech.ph";

/**
 * Confirmed legacy MTP that is not expired:
 * ACTIVE (running) or READY (admin-confirmed, not activated yet).
 * Everything else (inactive, waiting/paid, expired) goes to the landing page.
 */
export function mtpHandoffPath(mtpStatus) {
  const status = (mtpStatus || "").toString().toUpperCase();
  if (status === "ACTIVE" || status === "READY") return "/login";
  return "/";
}

function resolveLegacyUid(uid) {
  if (uid) return uid;
  try {
    const user = firebase.auth().currentUser;
    return (user && user.uid) || null;
  } catch (e) {
    return null;
  }
}

/**
 * Default path is /login. Launch modal free-mock CTA uses /start. Card CTAs use mtpHandoffPath.
 * utm_term carries the legacy Firebase uid so the MTP app / PostHog can attribute visitors.
 */
export function mtpAppUrl(content, path = "/login", uid = null) {
  const projectId = process.env.VUE_APP_FIREBASE_PROJECT_ID;
  const host = projectId === "skilltech-prod" ? PRODUCTION_MTP_APP_URL : STAGING_MTP_APP_URL;
  const url = new URL(path, host.endsWith("/") ? host : host + "/");
  url.searchParams.set("utm_source", "legacy_reviewer");
  url.searchParams.set("utm_medium", "cta");
  url.searchParams.set("utm_campaign", "mtp_app_launch");
  url.searchParams.set("utm_content", content);
  const legacyUid = resolveLegacyUid(uid);
  if (legacyUid) url.searchParams.set("utm_term", legacyUid);
  return url.toString();
}

export function openMtpApp(content, path = "/login", uid = null) {
  const url = mtpAppUrl(content, path, uid);
  const tab = window.open(url, "_blank");
  if (!tab) window.location.href = url;
}
